import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function InviteResponse() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    if (status === 'success') {
      navigate('/login');
    }
  }, [navigate]);

  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const company = params.get('company');

  if (status === 'success') {
    return <div>Redirecting to login...</div>;
  }

  return (
    <div style={{ padding: 20, textAlign: 'center' }}>
      <h1>Invite Response</h1>
      <p>Status: {status}</p>
      {company && <p>Company: {decodeURIComponent(company)}</p>}
      <p>Please contact the sender to request another invite if needed.</p>
    </div>
  );
}